export default "__VITE_ASSET__81c2a930__"